import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  Typography,
  Avatar,
  Divider,
} from "@mui/material";
import { Form, Formik } from "formik";
// import { errorMessage } from "../../utils/errorHandleFunctions";
import SendIcon from "@mui/icons-material/Send";
// import {
//   postNotification,
//   updateNotification,
// } from "../../services/notification.service";
import * as yup from "yup";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
// import { closeChat } from "../../redux/chat/chatActions";
// import { updateChat } from "../../services/chat.service";
import Styles from "../../assets/styles/Chat.module.scss";
import MenuOpenOutlinedIcon from "@mui/icons-material/MenuOpenOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
// import { usePermissions } from "../../services/permissionProvider";

const Chat = (props) => {
  const {
    setOpenChatDrawer,
    formType,
    getChatData,
    setRefreshKey,
    refreshKey,
  } = props;
  //   const { permissions, loading } = usePermissions();
  const currentUrl = window.location.href;
  const lastSegment = currentUrl.split("/").pop();
  const [action, setAction] = useState({});
  const formRef = useRef(null);
  const lastMessageRef = useRef(null);
  const chatBoxRef = useRef(null);
  const headerBoxRef = useRef(null);

  const [headBoxHeight, setHeadBoxHeight] = useState(0);
  const [replyText, setReplyText] = useState("");
  const [showHeaderBox, setShowHeaderBox] = useState(false);
  const dispatch = useDispatch();
  const userId = localStorage.getItem("userId");
  const name = localStorage.getItem("name");
  const role = localStorage.getItem("role");

  //   let currentChat = useSelector((state) => state.chat.currentViewedChat);
  const initialValues = {
    // title: currentChat.title || "",
    // roles: currentChat?.rolesData?.map((e) => e._id) || [],
    // acknowledgeBy: currentChat.acknowledgeBy || [],
    // message: currentChat.message || "",
  };

  const validationSchema = yup.object().shape({
    title: yup.string().required("Title Required *"),
    roles: yup
      .array()
      .of(yup.string().required("Select Role *"))
      .min(1, "At least one Role is required *"),
    message: yup.string().required("Message Required *"),
  });
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const onSubmit = async (values) => {
    try {
      const apiMethod = formType === "edit";
      //   ? updateNotification(currentChat._id, values)
      //   : postNotification(values);
      const res = await apiMethod;
      //   toastSuccess(res.message);
      getChatData();
      setOpenChatDrawer(false);
    } catch (error) {
      console.log(error);
    }
  };

  const onSave = async () => {
    try {
      //   dispatch(
      //     closeChat({
      //       data: {
      //         closedBy: userId,
      //         status: "Closed",
      //         _id: currentChat._id,
      //       },
      //     })
      //   ),
      //     getChatData();
      setOpenChatDrawer(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSendReply = async () => {
    if (replyText == "") {
      return;
    }
    const values = {
      user: userId,
      userData: {
        name: name,
      },
      message: replyText,
      time: moment(),
      isSeen: true,
    };
    const formData = new FormData();
    formData.append("bodyData", JSON.stringify(values));
    // updateChat(currentChat._id, formData).then(() => {
    //   setRefreshKey(refreshKey + 1);
    // });
    setReplyText("");
  };

  //   useEffect(() => {
  //     if (chatBoxRef.current) {
  //       chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
  //     }
  //   }, [currentChat.replies]);

  //   React.useEffect(() => {
  //     if (permissions.length > 0) {
  //       const matchedPermission = permissions.find(
  //         (permission) => permission.pageName === lastSegment
  //       );
  //       const { actions } = matchedPermission;
  //       setAction(actions);
  //     }
  //   }, [lastSegment, permissions]);

  //   useEffect(() => {
  //     if (headerBoxRef.current) {
  //       const boxHeight = headerBoxRef.current.offsetHeight;
  //       setHeadBoxHeight(boxHeight);
  //     }
  //   }, [currentChat]);

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSendReply();
    }
  };

  return (
    // <div
    //   style={{
    //     height: "calc(100vh - 58px)",
    //     display: "flex",
    //     flexDirection: "column",
    //     backgroundColor: "#E5DED8",
    //   }}
    // >
    //   <Box
    //     sx={{
    //       height: "fit-content",
    //       padding: "10px",
    //       display: "flex",
    //       justifyContent: "space-between",
    //       alignItems: "center",
    //       backgroundColor: "#eeeeee",
    //       borderBottom: "1px solid #d9d9d9",
    //       position: "relative",
    //     }}
    //     ref={headerBoxRef}
    //   >
    //     <Box sx={{ display: "flex", gap: "18px", alignItems: "center" }}>
    //       <Avatar sx={{ textTransform: "capitalize" }}>
    //         {/* {currentChat?.userData?.[0]?.name?.[0]} */}
    //       </Avatar>
    //       <Typography sx={{ textTransform: "capitalize" }}>
    //         {/* {currentChat?.userData?.[0]?.name}{" "}
    //         {currentChat?.supportId ? (
    //           <span style={{ opacity: "0.9" }}>
    //             {" "}
    //             - ({currentChat?.supportId})
    //           </span>
    //         ) : null} */}
    //       </Typography>
    //     </Box>
    //     {showHeaderBox ? (
    //       <CloseOutlinedIcon
    //         sx={{ cursor: "pointer" }}
    //         onClick={() => setShowHeaderBox(!showHeaderBox)}
    //       />
    //     ) : (
    //       <MenuOpenOutlinedIcon
    //         sx={{
    //           cursor: "pointer",
    //           //   display: currentChat?._id ? "block" : "none",
    //         }}
    //         onClick={() => setShowHeaderBox(!showHeaderBox)}
    //       />
    //     )}
    //     <Box
    //       sx={{
    //         position: "absolute",
    //         top: headBoxHeight,
    //         width: "100%",
    //         right: 0,
    //         display: showHeaderBox ? "block" : "none",
    //         zIndex: 10,
    //       }}
    //     >
    //       <Box
    //         sx={{
    //           padding: "12px",
    //           bgcolor: "#FFF1E3",
    //           height: "100%",
    //           width: "100%",
    //         }}
    //       >
    //         <Stack spacing={1}>
    //           <Stack
    //             direction={"row"}
    //             alignItems={"center"}
    //             justifyContent={"space-between"}
    //           >
    //             <Typography fontWeight={"600"} fontSize={"14px"}>
    //               {/* Chat ID {currentChat?.supportId} */}
    //             </Typography>
    //             {/* {currentChat?.status == "Open" ? (
    //               // (role === "OPERATION-MANAGER" ||
    //               //   role === "ASSISTANT-OPERATION-MANAGER" ||
    //               //   role === "HR-DEPARTMENT" ||
    //               //   role === "HSA-ADMIN" ||
    //               //   role === "Command Centre Officer" ||
    //               //   role === "WSH-ADMIN") && (
    //               action.delete && (
    //                 <Button onClick={handleClickOpen} className="closeButton">
    //                   Close
    //                 </Button>
    //               )
    //             ) : (
    //               // )
    //               <Button className="closeButton">Closed</Button>
    //             )} */}
    //           </Stack>
    //           <Stack>
    //             <Typography
    //               color={"#00675D"}
    //               fontWeight={"600"}
    //               fontSize={"14px"}
    //             >
    //               {/* {currentChat?.title} */}
    //             </Typography>
    //           </Stack>
    //           <Stack spacing={1} direction={"row"}>
    //             <Typography fontWeight={"600"} fontSize={"14px"}>
    //               Category:
    //             </Typography>
    //             <Typography fontSize={"14px"}>
    //               {/* {currentChat?.category} */}
    //             </Typography>
    //           </Stack>
    //           <Stack>
    //             <Typography
    //               color={"#141414"}
    //               fontSize={"14px"}
    //               fontWeight={"400"}
    //               lineHeight={"18px"}
    //             >
    //               {/* {currentChat?.description}{" "} */}
    //             </Typography>
    //           </Stack>
    //           <Stack>
    //             <Divider
    //               style={{
    //                 color: "#FBD9B9",
    //                 borderWidth: "1px",
    //               }}
    //             />
    //           </Stack>
    //           <Stack spacing={1} direction={"row"}>
    //             <Typography
    //               color={"#00675D"}
    //               fontWeight={"600"}
    //               fontSize={"14px"}
    //             >
    //               {/* {currentChat?.userData?.[0].name} */}
    //             </Typography>
    //             <Typography color={"#4D4D4D"} fontSize={"14px"}>
    //               {/* . {moment(currentChat?.createdAt).fromNow()} */}
    //             </Typography>
    //           </Stack>
    //         </Stack>
    //       </Box>
    //     </Box>
    //   </Box>
    //   <Box className={Styles.rightScrollBox} ref={chatBoxRef}>
    //     <Formik
    //       initialValues={initialValues}
    //       enableReinitialize
    //       validationSchema={validationSchema}
    //       onSubmit={onSubmit}
    //       innerRef={formRef}
    //     >
    //       <Form>
    //         <Box mb={1}>
    //           <Grid sx={{ backgroundColor: "#e5ded8", paddingTop: "20px" }}>
    //             {/* {currentChat.replies?.length > 0 &&
    //               currentChat.replies.map((data, index) =>
    //                 userId === data.user ? (
    //                   <Box
    //                     className={Styles.rightMsgContainer}
    //                     key={index}
    //                     ref={
    //                       index === currentChat.replies.length - 1
    //                         ? lastMessageRef
    //                         : null
    //                     }
    //                   >
    //                     <Box className={Styles.rightMsgBox}>
    //                       {data?.file?.fileName != null ? (
    //                         <Box>
    //                           <Typography className="inputLabel">
    //                             View File
    //                           </Typography>
    //                           <Typography
    //                             className="fileLinkStyle"
    //                             // onClick={() => viewPdf(data)}
    //                             target="_blank"
    //                             component="a"
    //                             href={data?.file?.location}
    //                           >
    //                             {data?.file?.fileName}
    //                           </Typography>
    //                         </Box>
    //                       ) : (
    //                         <Typography className={Styles.sendMsgContent}>
    //                           {data.message}
    //                         </Typography>
    //                       )}
    //                       <Typography className={Styles.sendTimeLabel}>
    //                         {moment(data.time).fromNow()}
    //                       </Typography>
    //                     </Box>
    //                   </Box>
    //                 ) : (
    //                   data.user != null &&
    //                   currentChat.replies.length > 0 && (
    //                     <Box
    //                       key={index}
    //                       className={Styles.leftMsgContainer}
    //                       ref={
    //                         index === currentChat.replies.length - 1
    //                           ? lastMessageRef
    //                           : null
    //                       }
    //                     >
    //                       <Box className={Styles.leftMsgBox}>
    //                         {data?.file?.fileName != null ? (
    //                           <Box>
    //                             <Typography className="inputLabel">
    //                               View File
    //                             </Typography>
    //                             <Typography
    //                               className="fileLinkStyle"
    //                               // onClick={() => viewPdf(data)}
    //                               target="_blank"
    //                               component="a"
    //                               href={data?.file?.location}
    //                             >
    //                               {data?.file?.fileName}
    //                             </Typography>
    //                           </Box>
    //                         ) : (
    //                           <Typography className={Styles.sendMsgContent}>
    //                             {data.message}
    //                           </Typography>
    //                         )}
    //                         <Typography className={Styles.sendTimeLabel}>
    //                           {moment(data.time).fromNow()}
    //                         </Typography>
    //                       </Box>
    //                     </Box>
    //                   )
    //                 )
    //               )} */}
    //           </Grid>
    //         </Box>
    //       </Form>
    //     </Formik>
    //   </Box>
    //   <Box>
    //     {/* {currentChat.status == "Open" && action.edit && (
    //       <Grid className={Styles.addchatboxFooter}>
    //         <input
    //           value={replyText}
    //           onChange={(e) => {
    //             setReplyText(e.target.value);
    //           }}
    //           onKeyDown={handleKeyPress}
    //           placeholder="Type a message"
    //           className={Styles.inputBox}
    //         />
    //         <SendIcon
    //           className={Styles.SendIcon}
    //           onClick={() => {
    //             handleSendReply();
    //           }}
    //           sx={{ color: "#00675D", fontSize: "24px", cursor: "pointer" }}
    //         />
    //       </Grid>
    //     )} */}
    //   </Box>
    //   <Dialog open={open} onClose={handleClose}>
    //     <DialogTitle>{"Close Chat"}</DialogTitle>
    //     <DialogContent>Are you sure you close chat ?</DialogContent>
    //     <DialogActions>
    //       <Button onClick={onSave} color="primary">
    //         Yes
    //       </Button>
    //       <Button onClick={handleClose} color="secondary">
    //         No
    //       </Button>
    //     </DialogActions>
    //   </Dialog>
    // </div>
    <div></div>
  );
};
export default Chat;
